import {IComponentOptions} from 'angular';
import IPromise = angular.IPromise;
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
declare let require: any;
declare let angular: any;
require('./dv-map.scss');

export class MapComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        lon: '=',
        lat: '=',
    };
    template = require('./dv-map.html');
    controller = DvMapController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvMapController {

    static $inject = ['$log', 'NgMap', '$window'];

    positions: Array<any> = [];

    lon: string;
    lat: string;

    gMap: any;

    constructor(private $log: ILogService, private NgMap: any, private $window: any) {
    }

    $onInit() {
        if (this.lon && this.lat) {
            this.positions.push({pos: [this.lat, this.lon]});
        }
    }

    public addMarker(event: any, that: DvMapController): void {
        let ll = event.latLng;

        that.positions = [];
        that.positions.push({pos: [ll.lat(), ll.lng()]});
        that.lon = that.getLonFromPosition();
        that.lat = that.getLatFromPosition();
    }

    public getCenter(): any {
        //Wenn marker vorhanden auf Marker zentieren
        if (this.lon && this.lat) {
            return [this.lat, this.lon];
        }
        //Sonst auf Schweiz zentieren
        return '[46.83389, 8.16833]'
    }

    public getZoom(): any {
        //Wenn marker vorhanden auf Marker zoomen
        if (this.lon && this.lat) {
            return 12;
        }
        //Sonst auf Schweiz zentieren
        return 7;
    }

    public getLonFromPosition(): string {
        if (this.positions && this.positions[0]) {
            return this.positions[0].pos[1];
        }
        return ''
    }

    public getLatFromPosition(): string {
        if (this.positions && this.positions[0]) {
            return this.positions[0].pos[0];
        }
        return ''
    }

    // This is needen bacause there are gray ares in map
    // see: https://github.com/allenhwkim/angularjs-google-maps#grey-area-in-google-maps
    public onMapLoaded() {
        // There is a bug in angular 1.6: Possibly unhandled rejection: could not find map
        // see: https://github.com/allenhwkim/angularjs-google-maps/issues/614
        let self = this;
        this.NgMap.getMap().then(function (map: any) {
            self.gMap = map;
            let center = map.getCenter();
            self.$window.google.maps.event.trigger(self.gMap, 'resize');
            map.setCenter(center);
        });
    }

}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-map/dv-map.ts